import { useEffect } from 'react'
import { Helmet } from 'react-helmet'

import { useBoundStore } from '../../store/store'

const METADATA: Record<
  string,
  { title: string; desc: string; keywords: string }
> = {
  "home": {
    title: 'El casino que más paga | MexPlay',
    desc: 'Bono de bienvenida del 100% extra en tu 1er depósito. Duplicamos tu 1er depósito hasta 5,000 pesos. Bono de casino del 15% ilimitado en todos tus depósitos. Retiros al instante',
    keywords: 'mexplay, casino mexplay, mejor casino, app casino',
  },
  "casino": {
    title: 'Casino',
    desc: 'Gana dinero real. Los mejores juegos online. 2000 juegos de casino esperando que te lleves el premio. Casino en vivo las 24 horas. Jackpots, Slots, Ruleta, Blackjack, Póker y más.',
    keywords: 'casino, casino online, casino en linea, juegos de slots online, juego de casino en linea, casino mexico, juegos de casino slots, descargar juegos de casino',
  },
  "deposit": {
    title: 'Deportes',
    desc: 'Casa de apuestas deportivas en línea. Apuesta a tu equipo favorito. Depósitos instantáneos. Transacciones seguras. Cobra tus ganancias fácilmente.',
    keywords: 'apuesta, app de apuestas, juego de apuestas, apuestas bono de bienvenida, apuesta online, apuestas deportivas, mejor casa de apuestas, nuevas paginas de apuestas',
  },
  "promotions": {
    title: 'Promociones',
    desc: 'Ofertas de bienvenida para nuevos jugadores. Promociones y bonificaciones para jugadores leales. Procesamiento rápido y seguro de pagos. Experiencia de juego en línea premium y segura. Refiere a tus amigos y gana comisión. Con MexPlay ganas más.',
    keywords: 'apuesta, app de apuestas, juego de apuestas, apuestas bono de bienvenida, apuesta online, bono de deposito, mejor casa de apuestas, nuevas paginas de apuestas',
  },
}

interface WebTitleProps {
  page: string
}

const WebTitle = ({ page }: WebTitleProps) => {
  const isUserLoading = useBoundStore(state => state.user.isLoading)

  useEffect(() => {
    if (isUserLoading) return

    fbq('track', 'ViewContent', {
      content_type: page,
    })
  }, [isUserLoading])

  if (!METADATA[page]) {
    return (
      <Helmet>
        <title>{METADATA['home'].title}</title>
        <meta name="description" content={METADATA['home'].desc} />
      </Helmet>
    )
  }

  return (
    <Helmet>
      <title>{METADATA[page].title}</title>
      <meta name="description" content={METADATA[page].desc} />
      {METADATA[page].keywords && (
        <meta name="keywords" content={METADATA[page].keywords} />
      )}
      {(!page ||
        !(
          ['home', 'casino', 'deposit', 'promotions'].includes(page) ||
          page.includes('blog')
        )) && <meta name="robots" content="noindex" />}
    </Helmet>
  )
}

export default WebTitle
